import type { ConsentText } from './types';

/**
 * The plot consent in Bengali (বাংলা). Follows en.ts key for key; see types.ts.
 */
export const bn: ConsentText = {
  selfName: 'বাংলা',
  englishName: 'ইংরেজি',
  labels: {
    stageDraft: 'কৃষকের পড়ার জন্য - এখনও স্বাক্ষর হয়নি',
    stagePaper: 'কৃষকের স্বাক্ষরের জন্য',
    stageSigned: 'সম্মতি দেওয়া হয়েছে',
    watermark: 'খসড়া',
    kindDraft: 'খসড়া সম্মতি',
    kindPaper: 'কাগজে সম্মতি',
    kindDigital: 'ডিজিটাল সম্মতি',
    record: 'নথি',
    page: 'পৃষ্ঠা',
    generated: 'তৈরি হয়েছে {at}',
    title: 'কৃষকের নিজের প্লটের জন্য সম্মতি',
    plot: 'প্লট',
    valid: 'বৈধ',
    validRange: '{from} থেকে {to} পর্যন্ত',
    membershipOfGroup: 'কৃষক উৎপাদক গোষ্ঠীর সদস্যপদ',
    farmerHeading: '1. কৃষক',
    name: 'নাম',
    memberCode: 'সদস্য কোড',
    fatherOrSpouse: 'পিতা / স্বামী বা স্ত্রী',
    gender: 'লিঙ্গ',
    age: 'বয়স',
    address: 'ঠিকানা',
    mobile: 'মোবাইল',
    email: 'ইমেল',
    consentLanguage: 'সম্মতির ভাষা',
    programmesHeading: 'এই সম্মতি যে কর্মসূচিগুলির জন্য',
    certificateReference: 'সার্টিফিকেট / সূত্র',
    validUntil: '{date} পর্যন্ত বৈধ',
    inScope: '{org}-এর আওতায়',
    membership: 'সদস্যপদ',
    membershipValue: '{org}-এর কৃষক উৎপাদক গোষ্ঠীর অংশ হিসেবে এই প্লট',
    agreeFarmer: 'আমি, {name}, নিশ্চিত করছি যে উপরের বিবরণগুলি আমার এবং সঠিক। পরের পৃষ্ঠাগুলিতে আমার প্লট, আমার তথ্য, এবং প্লটটি যে প্রতিটি কর্মসূচিতে আছে তার জন্য আমি কী কী মেনে নিচ্ছি, তা বলা আছে। এগুলি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এই সম্মতি দিচ্ছি। আমি যেকোনো সময় এটি প্রত্যাহার করার অনুরোধ করতে পারি।',
    plotHeading: '2. প্লট',
    village: 'গ্রাম',
    location: 'অবস্থান',
    centre: 'কেন্দ্রবিন্দু (অক্ষাংশ, দ্রাঘিমাংশ)',
    notMapped: 'সীমানা এখনও মানচিত্রে আঁকা হয়নি',
    declaredArea: 'ঘোষিত আয়তন (জমির রেকর্ড)',
    mappedArea: 'মানচিত্রে মাপা আয়তন',
    tenure: 'জমির মালিকানা / ভোগদখলের ধরন',
    landDocuments: 'জমির কাগজপত্র',
    trees: 'প্লটের গাছ',
    excision: 'বাদ দেওয়া অংশ (ঘোষিত)',
    boundaryHeading: 'সীমানা (GPS, অক্ষাংশ, দ্রাঘিমাংশ)',
    snapshotCaption: 'উপগ্রহ চিত্রে সীমানা',
    moreCorners: '... আরও {n}টি কোণ, অ্যাপে রাখা আছে',
    agreePlot: 'আমি রাজি যে পৃষ্ঠা 1-এর কর্মসূচিগুলির জন্য {org} এই প্লটটি নথিভুক্ত করতে, মানচিত্রে আঁকতে এবং নজরে রাখতে পারবে।',
    dataHeading: '3. আমার অংশগ্রহণ এবং আমার তথ্য',
    dutiesHeading: 'কর্মসূচিগুলির একজন অংশগ্রহণকারী হিসেবে আমি রাজি যে',
    informationHeading: 'আমার সম্পর্কে যে তথ্য রাখা হয়',
    collected: 'কী সংগ্রহ করা হয়',
    why: 'কেন',
    whoReceives: 'কারা আমার তথ্য পেতে পারে',
    howLong: 'কতদিন রাখা হয়',
    myRights: 'আমার অধিকার',
    toAsk: 'জানতে চাওয়া, অভিযোগ করা বা প্রত্যাহার করার জন্য',
    dataBoard: 'সমাধান না হলে, আমি ভারতের ডেটা প্রোটেকশন বোর্ডে (তথ্য সুরক্ষা বোর্ড) অভিযোগ করতে পারি।',
    agreeData: 'এই সম্মতিতে বলা উদ্দেশ্যগুলির জন্য আমার তথ্য সংগ্রহ ও ব্যবহার করায় আমি রাজি।',
    sharingHeading: '4. আমার তথ্য কীভাবে ব্যবহার ও ভাগ করা হতে পারে',
    withdrawingHeading: 'আমার সম্মতি প্রত্যাহার',
    iAgreeTo: 'আমি রাজি',
    iAmEntitled: 'আমার অধিকার আছে',
    agreeScope: 'প্লট {plot}-এর জন্য {scope} আমার কাছে কী চায় তা আমি বুঝেছি, এবং আমি তাতে রাজি।',
    recordHeading: 'সম্মতির নথি',
    consent: 'সম্মতি',
    consentValue: '{scopes}-এর জন্য প্লটের সম্মতি',
    farmer: 'কৃষক',
    recordId: 'নথির আইডি',
    givenByOtp: 'OTP দিয়ে সম্মতি দেওয়া হয়েছে',
    otpRef: 'OTP সূত্র',
    documentSha: 'নথির SHA-256',
    signatureOf: '{name}-এর স্বাক্ষর',
    thumb: 'বুড়ো আঙুলের ছাপ',
    witness: 'সাক্ষী (নাম ও স্বাক্ষর)',
    date: 'তারিখ',
    witnessFull: 'সাক্ষীর নাম ও স্বাক্ষর',
    officerFull: 'ফিল্ড অফিসারের নাম ও স্বাক্ষর',
    paperNote: 'কাগজে দেওয়া হলে: একজন সাক্ষীর সামনে এখানে এবং প্রতিটি পৃষ্ঠায় স্বাক্ষর করুন বা বুড়ো আঙুলের ছাপ দিন। ফিল্ড অফিসার এই স্বাক্ষরিত কপিটি আপলোড করবেন।',
    otpSentence: '{name}-এর সম্মতি {reached}-এ পাঠানো OTP-র মাধ্যমে নেওয়া হয়েছে এবং {day} তারিখে {time}-এ{by} যাচাই করা হয়েছে।',
    otpBy: ' {officer}-এর দ্বারা',
    registeredMobile: 'নথিভুক্ত মোবাইল',
    registeredEmail: 'নথিভুক্ত ইমেল',
    via: 'মাধ্যমে',
    and: 'ও',
    registeredContact: 'নথিভুক্ত যোগাযোগ',
    coversHeading: 'এই সম্মতি কী কী বিষয়ে',
    partiesHeading: 'কৃষকের সঙ্গে যাঁরা এই সম্মতি দিচ্ছেন',
    relationship: 'সম্পর্ক',
    termsHeading: 'ব্যবস্থার শর্তাবলি',
    termsBlank: 'ফসল বা বিক্রির টাকার ভাগ: ______ %    কাকে দেওয়া হবে: ________________',
    partiesBlank: 'নামগুলি হাতে লিখতে হবে, প্রত্যেকের নিচে তাঁর স্বাক্ষর সহ।',
    bothVersions: 'এই নথি ইংরেজিতে এবং কৃষকের নিজের ভাষায়, অর্থাৎ এই ভাষায় আছে। দুটিই একই সম্মতি; কৃষককে এই ভাষাতেই সম্মতিটি বুঝিয়ে বলা হয়েছিল।',
    partySignature: '{name}-এর স্বাক্ষর বা বুড়ো আঙুলের ছাপ',
    partiesNote: 'নাম লেখা প্রত্যেক ব্যক্তি একজন সাক্ষীর সামনে কাগজের কপির এই পৃষ্ঠায় স্বাক্ষর করবেন; কৃষক OTP বা স্বাক্ষরের মাধ্যমে সম্মতি দেবেন।',
  },
  kinds: {
    sale: {
      title: 'কৃষকের নিজের প্লটের ফসল কাটা ও বিক্রির জন্য সম্মতি',
      heading: 'এই প্লট থেকে ফসল কাটা ও বিক্রি',
      about: 'এই সম্মতি প্লট {plot}-এ ফসল কাটা এবং তার উৎপাদিত দ্রব্য - কাঠ, খুঁটি, মণ্ড কাঠ (পাল্পউড), জ্বালানি কাঠ, বাঁশ বা অন্যান্য ফসল - {org}-এর মাধ্যমে বিক্রি করা, এবং প্রতিটি বিক্রি কীভাবে নথিভুক্ত ও টাকা দেওয়া হবে, সেই বিষয়ে।',
      agreeLead: 'আমি রাজি যে',
      obligations: [
        'কেবল {org}-এর অভ্যন্তরীণ কাটার অনুমতি এবং আইনে প্রয়োজনীয় গাছ কাটা ও পরিবহনের অনুমতিপত্র নিয়েই কাটব, এবং কেবল চিহ্নিত গাছ ও পরিমাণই কাটব।',
        'প্রতিটি কাটার প্রজাতি, গাছের সংখ্যা এবং আয়তন বা ওজন সত্যি করে জানাব, এবং তা মাপতে, ছবি তুলতে ও এই প্লটের নামে নথিভুক্ত করতে দেব।',
        'এই প্লটের যে ফসলে সার্টিফিকেশন বা বন-উজাড়-মুক্ত দাবি আছে, তা কেবল {org} বা তার বলা ক্রেতার মাধ্যমেই বিক্রি করব, এবং অন্য কোথাও থেকে আসা ফসল কখনও তার সঙ্গে মেশাব না।',
        'প্রতিটি বিক্রি চালান (ইনভয়েস), পাঠানোর রসিদ (ডিসপ্যাচ ডকেট) ও পরিবহনের কাগজপত্র সহ নথিভুক্ত করাব, এবং প্রতিটি বিক্রির পরিমাণ ও টাকা আমার OTP বা স্বাক্ষর দিয়ে নিশ্চিত করব।',
        'ফসল এই প্লট পর্যন্ত খুঁজে বের করতে কোনো ক্রেতা, সার্টিফিকেশন সংস্থা বা কর্তৃপক্ষের যে প্লট, কাটা ও বিক্রির বিবরণ দরকার, {org}-কে তা ভাগ করতে দেব।',
        'সম্মত কাটছাঁট - ফসল কাটা ও পরিবহনের খরচ, অগ্রিম, উপকরণের ঋণ এবং গোষ্ঠীর ফি - বিক্রির টাকা থেকে কেটে নিতে দেব, যেমন আমার হিসাব বিবরণীতে দেখানো থাকবে।',
        'কাটার পরে ব্যবস্থাপনা পরিকল্পনা অনুযায়ী আবার গাছ লাগাব, বা স্বাভাবিকভাবে নতুন গাছ গজাতে দেব।',
        'গাছ, জমি বা ফসল নিয়ে কোনো বিরোধ হলে, বিক্রির আগেই সঙ্গে সঙ্গে {org}-কে জানাব।',
      ],
      rightsLead: 'আমার অধিকার আছে',
      rights: [
        'প্রতিটি বিক্রি নিশ্চিত করার আগে তার দর, পরিমাণ, কাটছাঁট ও হাতে পাওয়া টাকা জানার, এবং চালানের (ইনভয়েস) একটি কপি পাওয়ার।',
        '{org} যে সময়ের মধ্যে রাজি হয়েছে, তার মধ্যে হাতে পাওয়া টাকা আমার নিজের ব্যাংক অ্যাকাউন্টে পাওয়ার, এবং আমার হিসাব বিবরণীতে প্রতিটি টাকা দেখার।',
        'যে বিক্রির দর বা পরিমাণ আমি মানি না, তা প্রত্যাখ্যান করার।',
        'আমার প্লট থেকে যেকোনো বিক্রির নথি চাওয়ার।',
      ],
      agree: 'আমি, {name}, এই শর্তে প্লট {plot}-এর ফসল কাটা ও বিক্রিতে রাজি। এগুলি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এই সম্মতি দিচ্ছি। আমি যেকোনো সময় এটি প্রত্যাহার করার অনুরোধ করতে পারি।',
      consentValue: 'প্লট থেকে ফসল কাটা ও বিক্রির সম্মতি',
    },
    family: {
      title: 'পরিবারের যৌথ প্লটের জন্য পরিবারের সদস্যদের সম্মতি',
      heading: 'পরিবারের সদস্যদের সম্মতি',
      about: 'প্লট {plot} পরিবারের যৌথ মালিকানায় আছে, বা উত্তরাধিকারে পাওয়া এবং এখনও ভাগ হয়নি। {name} এটি {org}-এ নথিভুক্ত করছেন। নিচে নাম লেখা পরিবারের সদস্যরা নিশ্চিত করছেন যে তাঁরা এটি জানেন এবং তাতে রাজি।',
      agreeLead: 'আমরা, নিচে নাম লেখা পরিবারের সদস্যরা, রাজি যে',
      obligations: [
        '{name} এই প্লটটি {org}-এ নথিভুক্ত করতে, মানচিত্রে আঁকাতে ও নজরে রাখাতে, এবং {name} যে কর্মসূচিগুলিতে সম্মতি দিয়েছেন সেগুলিতে আনতে পারবেন।',
        '{name} এই প্লটে ফসল কাটার পরিকল্পনা করে তা করতে পারবেন, এবং {org}-এর মাধ্যমে তার ফসল বিক্রি করতে পারবেন।',
        'এই প্লটের ফসলের টাকা {name}-কে দেওয়া যেতে পারে; পরিবারের মধ্যে তা কীভাবে ভাগ হবে, তা পরিবারের নিজের বিষয়।',
        'এই প্লটের কোনো বাঁটোয়ারা, বিক্রি, বন্ধক বা বিরোধ, এবং কার হাতে প্লটটি আছে তাতে কোনো পরিবর্তন হলে, আমরা {org}-কে জানাব।',
        'এই সম্মতি যতদিন থাকবে, আমরা কেউ আলাদাভাবে এই প্লটের ফসল কাটব বা বিক্রি করব না, বা অন্য কারও কাছে এটি নথিভুক্ত করব না।',
        'আমাদের নাম, {name}-এর সঙ্গে আমাদের সম্পর্ক এবং আমাদের যোগাযোগের নম্বর এই সম্মতির সঙ্গে নথিভুক্ত করা যেতে পারে।',
      ],
      rightsLead: 'আমরা বুঝি যে',
      rights: [
        'এই সম্মতিতে জমির মালিক কে, বা তাতে কারও ভাগ কত, তা বদলায় না।',
        'আমাদের যে কেউ এই সম্মতি প্রত্যাহারের অনুরোধ করতে পারেন; তখন {org} দেখবে প্লটটি নথিভুক্ত থাকতে পারে কি না।',
        'আমরা প্রত্যেকে চাইলে {name} বা {org}-এর মাধ্যমে প্লটের নথি, ফসল কাটা ও বিক্রি দেখতে পারি।',
      ],
      agree: 'আমরা, উপরে নাম লেখা পরিবারের সদস্যরা, এবং আমি, {name}, এই সম্মতি আমাদের {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমরা বুঝি, এবং আমরা স্বেচ্ছায় এই সম্মতি দিচ্ছি।',
      consentValue: 'প্লটের জন্য পরিবারের সদস্যদের সম্মতি',
    },
    sharecrop: {
      title: 'প্লটের জন্য জমির মালিক ও বর্গাদারের সম্মতি',
      heading: 'জমির মালিক ও বর্গাদারের সম্মতি',
      about: 'প্লট {plot} বর্গা চাষের ব্যবস্থায় চাষ হয় (bargadar / adhiar, বর্গাদার / আধিয়ার)। প্লটটি {org}-এ নথিভুক্ত করা, তার ফসল কাটা ও বিক্রির আগে নিচে নাম লেখা জমির মালিক ও বর্গাদার দুজনেই রাজি হচ্ছেন।',
      agreeLead: 'আমরা, জমির মালিক ও বর্গাদার, রাজি যে',
      obligations: [
        'প্লটটি {org}-এ নথিভুক্ত করা, মানচিত্রে আঁকা ও নজরে রাখা যেতে পারে, এবং এর জন্য যে কর্মসূচিগুলিতে সম্মতি দেওয়া হয়েছে সেগুলিতে আনা যেতে পারে।',
        'ফসলের, বা বিক্রির টাকার, ভাগ নিচের শর্তাবলিতে যেমন লেখা আছে তেমনই হবে; {org} বিক্রির নথিতে প্রত্যেকের ভাগ দেখাবে।',
        'ফসল কাটার পরিকল্পনা ও কাজ বর্গাদার করবেন, জমির মালিককে জানিয়ে, {org}-এর অভ্যন্তরীণ কাটার অনুমতি এবং আইনে প্রয়োজনীয় প্রতিটি অনুমতিপত্র নিয়ে।',
        'প্লটের ফসল {org}-এর মাধ্যমে বিক্রি হবে, এই প্লটের নামে নথিভুক্ত হবে, এবং অন্য কোথাও থেকে আসা ফসলের সঙ্গে কখনও মেশানো হবে না।',
        'টাকা নিচের শর্তাবলি অনুযায়ী দেওয়া হবে: আমাদের প্রত্যেককে নিজের ভাগ, অথবা যাঁর নাম টাকা নেওয়ার জন্য লেখা আছে তাঁকে।',
        'ব্যবস্থায় কোনো পরিবর্তন, কোনো বিরোধ, বা ব্যবস্থা শেষ হলে, আমাদের যে কেউ সঙ্গে সঙ্গে {org}-কে জানাবেন।',
      ],
      rightsLead: 'আমরা বুঝি যে',
      rights: [
        'এই সম্মতি কেবল ব্যবস্থাটি নথিভুক্ত করে; এতে জমির মালিকানা, বা আইনে বর্গাদারের যে অধিকার আছে তা, বদলায় না।',
        'আমরা প্রত্যেকে প্লটের ফসল কাটা ও বিক্রির নথি এবং প্রতিটি বিক্রিতে নিজের ভাগ দেখতে পারি।',
        'আমাদের যে কেউ এই সম্মতি প্রত্যাহারের অনুরোধ করতে পারেন; তখন {org} দেখবে প্লটটি নথিভুক্ত থাকতে পারে কি না।',
      ],
      agree: 'আমরা, উপরে নাম লেখা জমির মালিক ও বর্গাদার, এই সম্মতি আমাদের {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমরা বুঝি, এবং আমরা স্বেচ্ছায় এই সম্মতি দিচ্ছি।',
      consentValue: 'প্লটের জন্য জমির মালিক ও বর্গাদারের সম্মতি',
    },
    representative: {
      title: 'প্রতিনিধি নিয়োগের জন্য কৃষকের সম্মতি',
      heading: 'প্রতিনিধি',
      about: '{name} নিচে নাম লেখা ব্যক্তিকে {org}-এর কাছে তাঁর হয়ে কাজ করার জন্য নিয়োগ করছেন - কেবল নিচে টিক দেওয়া বিষয়গুলিতে এবং কেবল উল্লেখ করা প্লটগুলির জন্য।',
      agreeLead: 'আমি রাজি যে',
      obligations: [
        'আমার প্রতিনিধি কেবল উপরে টিক দেওয়া বিষয়গুলিতে এবং কেবল উল্লেখ করা প্লটগুলির জন্য কাজ করবেন; অন্য সব কিছুর জন্য আমাকেই লাগবে।',
        'এই বিষয়গুলিতে আমার প্রতিনিধি যা নিশ্চিত করবেন, তা আমার উপর এমনভাবে খাটবে যেন আমি নিজেই নিশ্চিত করেছি।',
        '{org} এই বিষয়গুলির বার্তা ও কোড আমার প্রতিনিধিকে তাঁর নিজের মোবাইল নম্বরে পাঠাতে পারে।',
        'আমার প্রতিনিধির আর আমার হয়ে কাজ করা উচিত না হলে, আমি সঙ্গে সঙ্গে {org}-কে জানাব।',
      ],
      rightsLead: 'আমি বুঝি যে',
      rights: [
        'আমিই সদস্য এবং আমার প্লটগুলির অধিকারী থাকি; প্রতিনিধি নিয়োগ করলে আমার জমি, আমার ফসল বা আমার টাকা অন্য কারও হাতে চলে যায় না।',
        'আমি লিখিতভাবে অন্য কিছু না বললে, আমার ফসলের টাকা আমার নিজের অ্যাকাউন্টেই দেওয়া হবে।',
        'আমি যেকোনো সময় এই নিয়োগ শেষ করতে পারি; যা-ই হোক, দেখানো তারিখে এটি শেষ হয়ে যায়।',
      ],
      agree: 'আমি, {name}, এই শর্তে আমার প্রতিনিধিকে নিয়োগ করছি, এবং আমার প্রতিনিধি এই শর্তগুলি মেনে নিচ্ছেন। এগুলি আমাদের {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমরা বুঝি, এবং আমরা স্বেচ্ছায় এই সম্মতি দিচ্ছি।',
      consentValue: 'প্রতিনিধি নিয়োগ',
      powersHeading: 'যে বিষয়গুলিতে প্রতিনিধি কাজ করতে পারেন',
      powers: {
        acknowledge: 'আমার হয়ে সম্মতি ও নথি স্বীকার করা, তাঁর নিজের মোবাইলে পাঠানো কোড দিয়ে',
        confirmSale: 'আমার বিক্রির পরিমাণ ও টাকার অঙ্ক নিশ্চিত করা',
        receivePayment: 'আমার টাকা দেওয়ার বার্তা পাওয়া',
      },
      plotsAll: 'আমার সব প্লট',
      plotsSome: 'প্লট: {plots}',
    },
    dataProcessing: {
      title: 'নিজের তথ্য সংগ্রহ ও ব্যবহারের জন্য কৃষকের সম্মতি',
      heading: 'আমার তথ্য',
      about: '{name}-কে সদস্য হিসেবে নথিভুক্ত করতে, এবং তিনি যে কর্মসূচি, বিক্রি ও টাকা দেওয়ায় অংশ নেন সেগুলি চালাতে, {org} তাঁর সম্পর্কে তথ্য সংগ্রহ করে ও রাখে। এই সম্মতি সেই তথ্য এবং তা কীভাবে ব্যবহার হয়, সেই বিষয়ে।',
      agreeLead: 'আমি রাজি যে',
      obligations: [
        '{org} আমার নাম, পরিবারের বিবরণ, ঠিকানা, ফোন ও ইমেল, ছবি, পরিচয়পত্র ও জমির কাগজের নম্বর (আংশিক ঢাকা অবস্থায় রাখা), এবং আমার প্লট, ফসল কাটা, বিক্রি ও টাকার বিবরণ সংগ্রহ করতে পারে।',
        'এই তথ্য আমাকে নথিভুক্ত করতে, আমার পরিচয় ও আমার জমি যাচাই করতে, আমি যে কর্মসূচিতে যোগ দিই সেগুলি চালাতে, এবং আমার ফসল নথিভুক্ত করতে ও তার টাকা দিতে ব্যবহার করা যেতে পারে।',
        'প্রতিটি কর্মসূচি, বিক্রি বা নথির জন্য আমি যে সম্মতি দিই কেবল সেই অনুযায়ী, এবং আইনে প্রয়োজন হলে কর্তৃপক্ষের সঙ্গে, এই তথ্য ভাগ করা যেতে পারে।',
        'আমি আমার বিবরণ হালনাগাদ রাখব, এবং তা বদলালে {org}-কে জানাব।',
      ],
      rightsLead: 'আমার অধিকার আছে',
      rights: [
        'আমার সম্পর্কে রাখা তথ্য দেখার, এবং তা সংশোধন বা সম্পূর্ণ করানোর।',
        'কোনো আইন বা কর্মসূচির আর প্রয়োজন না থাকলে তা মুছে ফেলানোর।',
        'যেকোনো সময় এই সম্মতি প্রত্যাহার করার; আইন বা কোনো কর্মসূচি দাবি করলে, ইতিমধ্যে ব্যবহার হওয়া তথ্য রেখে দেওয়া হতে পারে।',
        'আমার হয়ে কাজ করার জন্য কাউকে মনোনীত করার, এবং আমার উদ্বেগের সমাধান না হলে ভারতের ডেটা প্রোটেকশন বোর্ডে (তথ্য সুরক্ষা বোর্ড) অভিযোগ করার।',
      ],
      agree: 'আমি, {name}, যেভাবে বলা হয়েছে সেভাবে আমার তথ্য সংগ্রহ ও ব্যবহারে রাজি। এটি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এই সম্মতি দিচ্ছি।',
      consentValue: 'তথ্য সংগ্রহ ও ব্যবহারের সম্মতি',
    },
    trading: {
      title: 'কৃষক উৎপাদক গোষ্ঠীর মাধ্যমে নিজের ফসল বিক্রির জন্য কৃষকের সম্মতি',
      heading: 'আমার ফসল বিক্রি',
      about: '{name} {org}-এর মাধ্যমে ফসল বিক্রি করেন। বিক্রি কীভাবে করা, নথিভুক্ত ও নিশ্চিত করা হয় এবং তার টাকা কীভাবে দেওয়া হয়, এই সম্মতি সেই বিষয়ে।',
      agreeLead: 'আমি রাজি যে',
      obligations: [
        'যে ফসলে সার্টিফিকেশন বা বন-উজাড়-মুক্ত দাবি আছে, তা কেবল {org} বা তার বলা ক্রেতার মাধ্যমেই বিক্রি করব, এবং অন্য কোথাও থেকে আসা ফসল কখনও তার সঙ্গে মেশাব না।',
        'প্রতিটি বিক্রি চালান (ইনভয়েস), পাঠানোর রসিদ ও পরিবহনের কাগজপত্র সহ নথিভুক্ত করাব, এবং তার পরিমাণ ও টাকা আমার OTP বা স্বাক্ষর দিয়ে নিশ্চিত করব।',
        'ফসলের উৎস খুঁজে বের করার জন্য, {org}-কে বিক্রি, ফসল এবং তা কোথা থেকে এসেছে তার বিবরণ ক্রেতা, সার্টিফিকেশন সংস্থা ও কর্তৃপক্ষের সঙ্গে ভাগ করতে দেব।',
        'সম্মত কাটছাঁট - অগ্রিম, উপকরণের ঋণ, পরিবহন ও গোষ্ঠীর ফি - বিক্রির টাকা থেকে কেটে নিতে দেব, যেমন আমার হিসাব বিবরণীতে দেখানো থাকবে।',
      ],
      rightsLead: 'আমার অধিকার আছে',
      rights: [
        'প্রতিটি বিক্রি নিশ্চিত করার আগে তার দর, পরিমাণ, কাটছাঁট ও হাতে পাওয়া টাকা জানার, এবং চালানের (ইনভয়েস) একটি কপি পাওয়ার।',
        'সম্মত সময়ের মধ্যে আমার নিজের ব্যাংক অ্যাকাউন্টে টাকা পাওয়ার, এবং আমার হিসাব বিবরণীতে প্রতিটি টাকা দেখার।',
        'যে বিক্রির দর বা পরিমাণ আমি মানি না, তা প্রত্যাখ্যান করার।',
      ],
      agree: 'আমি, {name}, এতে রাজি। এটি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এই সম্মতি দিচ্ছি। আমি যেকোনো সময় এটি প্রত্যাহার করার অনুরোধ করতে পারি।',
      consentValue: 'কৃষক উৎপাদক গোষ্ঠীর মাধ্যমে বিক্রির সম্মতি',
    },
    documentShare: {
      title: 'নিজের নথি ভাগ করার জন্য কৃষকের সম্মতি',
      heading: 'আমার নথি ভাগ করা',
      about: '{org}-কে হয়তো কোনো ক্রেতা, নিরীক্ষক (অডিটর) বা কর্তৃপক্ষকে {name}, তাঁর প্লট বা তাঁর ফসল সম্পর্কে নথি দেখাতে হতে পারে। এই সম্মতি একটি সুরক্ষিত লিঙ্কের মাধ্যমে সেগুলি ভাগ করার বিষয়ে।',
      agreeLead: 'আমি রাজি যে',
      obligations: [
        '{org} আমার নথি ও কাগজপত্রের কপি - জমি, সার্টিফিকেশন, ফসল কাটা, বিক্রি ও উৎস খুঁজে বের করার কাগজ - প্রতিটি ভাগে যাঁর নাম লেখা আছে তাঁর সঙ্গে, তাতে লেখা উদ্দেশ্যে, ভাগ করতে পারে।',
        'প্রতিটি ভাগ একটি সুরক্ষিত লিঙ্ক হিসেবে পাঠানো হয়, যার মেয়াদ শেষ হয়ে যায়, এবং তা খুলতে একটি কোড লাগতে পারে।',
        'আইনে পুরো নম্বর দরকার না হলে, ভাগ করা নথিতে পরিচয়ের নম্বর আংশিক ঢাকা থাকে।',
      ],
      rightsLead: 'আমার অধিকার আছে',
      rights: [
        'কী ভাগ করা হয়েছে, কার সঙ্গে এবং কখন, তা জানার।',
        'যে ভাগ এখনও খোলা হয়নি, তা বন্ধ করতে {org}-কে বলার।',
        'ভবিষ্যতের ভাগগুলির জন্য যেকোনো সময় এই সম্মতি প্রত্যাহার করার।',
      ],
      agree: 'আমি, {name}, এতে রাজি। এটি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এই সম্মতি দিচ্ছি। আমি যেকোনো সময় এটি প্রত্যাহার করার অনুরোধ করতে পারি।',
      consentValue: 'নথি ভাগ করার সম্মতি',
    },
    payment: {
      title: 'কীভাবে টাকা দেওয়া হবে, তার জন্য কৃষকের সম্মতি',
      heading: 'আমার টাকা পাওয়া',
      about: '{org} {name}-কে তাঁর ফসল ও পরিষেবার জন্য টাকা দেয়। টাকা কোথায় দেওয়া হয় এবং কীভাবে নথিভুক্ত হয়, এই সম্মতি সেই বিষয়ে।',
      agreeLead: 'আমি রাজি যে',
      obligations: [
        'আমি লিখিতভাবে অন্য কোনো অ্যাকাউন্টের অনুমতি না দিলে, আমার টাকা নথিতে থাকা আমার নিজের ব্যাংক অ্যাকাউন্টে দেওয়া হবে।',
        'সম্মত কাটছাঁট - অগ্রিম, উপকরণের ঋণ, গোষ্ঠীর ফি এবং আইনে প্রয়োজনীয় কর - টাকা দেওয়ার আগে কেটে নেওয়া যেতে পারে, এবং তা আমার হিসাব বিবরণীতে দেখানো থাকবে।',
        'আমার ব্যাংক অ্যাকাউন্ট বদলালে সঙ্গে সঙ্গে {org}-কে জানাব, এবং আমার হিসাব বিবরণীতে প্রতিটি টাকা মিলিয়ে দেখব।',
        'টাকা দেওয়ার বার্তা আমার নথিভুক্ত মোবাইল, ইমেল বা WhatsApp-এ পাঠানো যেতে পারে।',
      ],
      rightsLead: 'আমার অধিকার আছে',
      rights: [
        'এমন একটি হিসাব বিবরণী পাওয়ার, যাতে প্রতিটি পাওনা টাকা, প্রতিটি কাটছাঁট এবং প্রতিটি দেওয়া টাকা দেখানো থাকে।',
        'যেকোনো টাকা বা কাটছাঁট নিয়ে প্রশ্ন তোলার, এবং তার ব্যাখ্যা পাওয়ার।',
        'যেকোনো সময় এই সম্মতি প্রত্যাহার করার; ইতিমধ্যে দেওয়া টাকা বহাল থাকবে।',
      ],
      agree: 'আমি, {name}, এতে রাজি। এটি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এই সম্মতি দিচ্ছি। আমি যেকোনো সময় এটি প্রত্যাহার করার অনুরোধ করতে পারি।',
      consentValue: 'টাকা দেওয়ার সম্মতি',
    },
    membership: {
      title: 'কৃষক উৎপাদক গোষ্ঠীর সদস্যপদের জন্য কৃষকের সম্মতি',
      heading: 'সদস্যপদ',
      about: '{name} {org}-এর কৃষক উৎপাদক গোষ্ঠীতে যোগ দিচ্ছেন। সদস্যপদ তাঁর জন্য কী বোঝায়, এই সম্মতি সেই বিষয়ে।',
      agreeLead: 'সদস্য হিসেবে, আমি রাজি যে',
      obligations: [
        'গোষ্ঠীর নিয়ম এবং আমি যে কর্মসূচিতে যোগ দিই তার শর্তগুলি মেনে চলব, এবং তার প্রশিক্ষণ, পরিদর্শন ও সভায় অংশ নেব।',
        'সত্য নথি রাখব, এবং কখনও অন্য কোনো জায়গার ফসলকে আমার নিজের বলে চালাব না।',
        'আমার জমি, তার মালিকানা বা তার ব্যবহারে কোনো পরিবর্তন হলে {org}-কে জানাব।',
      ],
      rightsLead: 'সদস্য হিসেবে, আমার অধিকার আছে',
      rights: [
        'গোষ্ঠীর কর্মসূচি ও বিক্রিতে অংশ নেওয়ার, এবং আমাকে প্রভাবিত করে এমন সিদ্ধান্ত জানার।',
        'কোনো উদ্বেগ বা অভিযোগ জানানোর, এবং তার জন্য আমার সঙ্গে আচরণে কোনো প্রভাব পড়বে না।',
        'গোষ্ঠী ছেড়ে দেওয়ার; আমার কর্মসূচি ও বিক্রির উপর তার কী প্রভাব পড়বে, {org} তা বুঝিয়ে বলবে।',
      ],
      agree: 'আমি, {name}, এতে রাজি। এটি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এই সম্মতি দিচ্ছি। আমি যেকোনো সময় এটি প্রত্যাহার করার অনুরোধ করতে পারি।',
      consentValue: 'সদস্যপদের সম্মতি',
    },
    portalAccess: {
      title: 'অনলাইন পোর্টাল ব্যবহারের জন্য কৃষকের সম্মতি',
      heading: 'অনলাইনে দেখার সুযোগ',
      about: '{org} {name}-কে তাঁর নিজের নথি অনলাইনে দেখার সুযোগ দেয়; তিনি নথিভুক্ত মোবাইল বা ইমেলে পাঠানো কোড দিয়ে প্রবেশ (সাইন ইন) করেন।',
      agreeLead: 'আমি রাজি যে',
      obligations: [
        'আমাকে পাঠানো কোড গোপন রাখব, এবং {org}-এর কর্মী সহ কারও সঙ্গে কখনও তা ভাগ করব না।',
        'পোর্টাল কেবল আমার নিজের নথির জন্যই ব্যবহার করব, এবং অন্য কেউ আমার অ্যাকাউন্ট ব্যবহার করেছে বলে মনে হলে সঙ্গে সঙ্গে {org}-কে জানাব।',
        'আমার অ্যাকাউন্ট সুরক্ষিত রাখতে, আমি কখন ও কোথা থেকে প্রবেশ করি তা {org}-কে নথিভুক্ত করতে দেব।',
      ],
      rightsLead: 'আমার অধিকার আছে',
      rights: [
        'আমার নথি, প্লট, ফসল কাটা, বিক্রি, টাকা ও সম্মতি অনলাইনে দেখার।',
        'চাইলে যেকোনো সময় আমার অনলাইন সুযোগ বন্ধ করানোর।',
      ],
      agree: 'আমি, {name}, এতে রাজি। এটি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এই সম্মতি দিচ্ছি। আমি যেকোনো সময় এটি প্রত্যাহার করার অনুরোধ করতে পারি।',
      consentValue: 'পোর্টাল ব্যবহারের সম্মতি',
    },
    harvestRequest: {
      title: 'নিজের প্লটে ফসল কাটার জন্য কৃষকের সম্মতি',
      heading: 'ফসল কাটা',
      about: '{name} {org}-কে তাঁর প্লটে ফসল কাটার ব্যবস্থা করতে বা অনুমতি দিতে বলছেন। ফসল কাটার পরিকল্পনা, কাজ ও নথিভুক্তি কীভাবে হবে, এই সম্মতি সেই বিষয়ে।',
      agreeLead: 'আমি রাজি যে',
      obligations: [
        'কেবল {org}-এর অভ্যন্তরীণ কাটার অনুমতি এবং আইনে প্রয়োজনীয় প্রতিটি অনুমতিপত্র নিয়ে, কেবল চিহ্নিত গাছ ও পরিমাণই কাটব।',
        'ফসল মাপতে, ছবি তুলতে ও আমার প্লটের নামে নথিভুক্ত করতে দেব, এবং কাটার পরে জায়গাটি পরীক্ষা করতে দেব।',
        'ব্যবস্থাপনা পরিকল্পনা অনুযায়ী আবার গাছ লাগাব, বা স্বাভাবিকভাবে নতুন গাছ গজাতে দেব।',
      ],
      rightsLead: 'আমার অধিকার আছে',
      rights: [
        'ফসল কাটা শুরুর আগে কোন গাছ চিহ্নিত হয়েছে এবং আনুমানিক পরিমাণ কত, তা জানার।',
        'আমার প্লটের ফসল কাটার নথি ও ফলনের হিসাব বিবরণী দেখার।',
      ],
      agree: 'আমি, {name}, এতে রাজি। এটি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এই সম্মতি দিচ্ছি। আমি যেকোনো সময় এটি প্রত্যাহার করার অনুরোধ করতে পারি।',
      consentValue: 'ফসল কাটার সম্মতি',
    },
    eudrClaim: {
      title: 'নিজের ফসলে EUDR ও FSC দাবির জন্য কৃষকের সম্মতি',
      heading: 'আমার ফসলের দাবি',
      about: '{org} {name}-এর প্লটের ফসল EUDR বন-উজাড়-মুক্ত দাবি বা FSC দাবি সহ বিক্রি করে। এই দাবিগুলির জন্য যে তথ্য দরকার, এই সম্মতি সেই বিষয়ে।',
      agreeLead: 'আমি রাজি যে',
      obligations: [
        'আমার প্লটের ভৌগোলিক অবস্থান, এবং আমার ফসল কাটা ও বিক্রির নথি, যথাযথ যাচাই বিবৃতি (ডিউ ডিলিজেন্স স্টেটমেন্ট) ও দাবির নথিতে ক্রেতা ও কর্তৃপক্ষের সঙ্গে ভাগ করা যেতে পারে।',
        'কেবল যতদিন আমার প্লট শর্তগুলি পূরণ করে, ততদিনই ফসল দাবি সহ বিক্রি হবে, এবং আমি অন্য কোথাও থেকে আসা ফসল আলাদা রাখব।',
        'বিধি অনুযায়ী এই তথ্য অন্তত পাঁচ বছর রাখা হতে পারে।',
      ],
      rightsLead: 'আমার অধিকার আছে',
      rights: [
        'আমার প্লট সম্পর্কে কী এবং কার সঙ্গে ভাগ করা হয়, তা জানার।',
        'আমার ফসল থেকে কোনো দাবি তুলে নেওয়া হলে, তা এবং তার কারণ জানার।',
      ],
      agree: 'আমি, {name}, এতে রাজি। এটি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এই সম্মতি দিচ্ছি। আমি যেকোনো সময় এটি প্রত্যাহার করার অনুরোধ করতে পারি।',
      consentValue: 'EUDR ও FSC দাবির সম্মতি',
    },
    withdrawal: {
      title: 'কৃষকের সম্মতি প্রত্যাহার',
      heading: 'প্রত্যাহার',
      about: '{name} নিচে দেখানো প্লট বা সদস্যপদের জন্য {org}-কে দেওয়া তাঁর সম্মতি প্রত্যাহার করছেন।',
      agreeLead: 'আমি বুঝি যে',
      obligations: [
        'যে তারিখে এটি কার্যকর হবে, সেদিন থেকে দেখানো প্লটগুলি আর কর্মসূচিতে নথিভুক্ত থাকবে না, এবং {org}-এর মাধ্যমে সেগুলি থেকে নতুন কোনো ফসল কাটা বা বিক্রি হবে না।',
        'আইন, কোনো সার্টিফিকেশন বা কোনো কর্মসূচির প্রয়োজন হলে, ইতিমধ্যে ব্যবহার বা ভাগ করা তথ্য রেখে দেওয়া হতে পারে।',
        'আমার যে টাকা ইতিমধ্যে পাওনা, তা আগের মতোই দেওয়া হবে।',
      ],
      rightsLead: 'আমার অধিকার আছে',
      rights: [
        'আমার বিক্রি, টাকা ও কর্মসূচির উপর প্রত্যাহারের কী প্রভাব পড়বে, তা জানার।',
        'পরে আবার, নতুন সম্মতি হিসেবে, সম্মতি দেওয়ার।',
      ],
      agree: 'আমি, {name}, যেমন দেখানো আছে তেমনভাবে আমার সম্মতি প্রত্যাহার করছি। এটি আমাকে {languages} ভাষায় বুঝিয়ে বলা হয়েছে, যা আমি বুঝি, এবং আমি স্বেচ্ছায় এটি করছি।',
      consentValue: 'সম্মতি প্রত্যাহার',
      plots: 'প্রত্যাহার করা প্লট',
      reason: 'কারণ',
      effective: 'কার্যকর হওয়ার তারিখ',
      allPlots: 'সদস্যপদ ও সব প্লট',
    },
    amendment: {
      title: 'কৃষকের সম্মতির সংশোধনী',
      heading: 'কী বদলাচ্ছে',
      about: 'শুধু নিচের বিষয়গুলি বদলাচ্ছে। স্বাক্ষরিত সম্মতির বাকি প্রতিটি কথা যেমন ছিল তেমনই থাকছে।',
      agreeLead: 'কী একই থাকছে',
      obligations: [
        'জমি, তার সীমানা ও কোণগুলি, যেমন স্বাক্ষরিত সম্মতিতে লেখা আছে।',
        '{org} আমার তথ্য নিয়ে কী করতে পারে, এবং কার সঙ্গে তা ভাগ করতে পারে।',
        'যে কোনও সময়, বিনা খরচে, আমার সম্মতি প্রত্যাহারের অধিকার।',
      ],
      rightsLead: 'আমার অধিকার আছে',
      rights: [
        'স্বাক্ষরের আগে এই সংশোধনীটি আমি বুঝি এমন ভাষায় আমাকে পড়ে শোনানো হোক।',
        'এটি অস্বীকার করা: তখন আমার সম্মতি ঠিক যেমন স্বাক্ষর করেছিলাম তেমনই থাকবে।',
      ],
      agree: 'আমি, {name}, নিশ্চিত করছি যে দেখানো পরিবর্তনগুলি আমি চেয়েছিলাম, সেগুলি আমাকে {languages} ভাষায় বুঝিয়ে দেওয়া হয়েছে, এবং আমি সেগুলিতে সম্মত। আমার সম্মতির বাকি সব কিছু যেমন স্বাক্ষর করেছিলাম তেমনই থাকছে।',
      consentValue: 'সম্মতির সংশোধনী নং {n}',
      numbered: 'সংশোধনী নং {n}',
      originalHeading: 'যে সম্মতির এই সংশোধনী',
      consentAmended: 'সংশোধিত সম্মতি',
      givenOn: 'দেওয়া হয়েছিল',
      askedFor: 'সংশোধনী চাওয়া হয়েছে',
      reason: 'কারণ',
      item: 'বিষয়', was: 'আগে', now: 'এখন',
      changeItems: { mobile: 'মোবাইল', email: 'ইমেল', address: 'ঠিকানা', valid_to: 'বৈধ থাকবে', scope_codes: 'এই সম্মতি যে কর্মসূচিগুলির জন্য', rights_holder: 'অধিকারধারীর নাম', other: 'অন্যান্য' },
    },
  },
  genders: { female: 'মহিলা', male: 'পুরুষ', other: 'অন্যান্য', undisclosed: 'বলতে চাই না' },
  commonRights: [
    'আমার প্লটে কী পাওয়া গেছে এবং কেন, তা জানার, এবং সে বিষয়ে কোনো সিদ্ধান্ত নেওয়ার আগে আমার উত্তর দেওয়ার অধিকার।',
    'কোনো উদ্বেগ বা অভিযোগ জানানোর অধিকার, এবং তার জন্য আমার সঙ্গে আচরণে কোনো প্রভাব পড়বে না।',
    'যেকোনো সময় আমার সম্মতি প্রত্যাহারের অনুরোধ করার অধিকার; এই কর্মসূচিতে আমার অংশগ্রহণের উপর তার কী প্রভাব পড়তে পারে, {org} তা বুঝিয়ে বলবে।',
  ],
  scopes: {
    FSC_FM: {
      title: 'FSC বন ব্যবস্থাপনা (গোষ্ঠী সার্টিফিকেশন)',
      about: 'ফরেস্ট স্টুয়ার্ডশিপ কাউন্সিল (FSC) প্রমাণপত্র দেয় যে গাছ দায়িত্বের সঙ্গে লাগানো ও কাটা হয়। {org}-এর FSC গোষ্ঠীর সদস্য হিসেবে আমার প্লট সার্টিফায়েড।',
      obligations: [
        'আমার জমিতে আইন মেনে চলব: জমির অধিকার, গাছ কাটা ও পরিবহনের অনুমতিপত্র, কর, এবং শ্রমিক, বন্যপ্রাণী ও জল রক্ষার আইন।',
        'আমার প্লটের জন্য কৃষক উৎপাদক গোষ্ঠীর ব্যবস্থাপনা পরিকল্পনা ও নিয়ম মেনে চলব; আমার কাছে যে নথি রাখতে বলা হয় তা রাখব; আমার জমি বা তার ব্যবহারে কোনো পরিবর্তন হলে কৃষক উৎপাদক গোষ্ঠীকে জানাব।',
        'কেবল কৃষক উৎপাদক গোষ্ঠীর অভ্যন্তরীণ কাটার অনুমতি এবং প্রয়োজনীয় বন দপ্তরের অনুমতি নিয়েই গাছ কাটব, কেবল চিহ্নিত গাছই কাটব, এবং কাটার পরে আবার গাছ লাগাব বা স্বাভাবিকভাবে নতুন গাছ গজাতে দেব।',
        'নদী-নালা ও জলাশয়ের ধারে, এবং উচ্চ সংরক্ষণ মূল্যের এলাকা, পবিত্র স্থান ও সমাধিস্থলের চারপাশে ফাঁকা সুরক্ষিত অংশ (বাফার) রাখব; বিরল ও বিপন্ন গাছপালা ও প্রাণী রক্ষা করব, এবং তাদের শিকার করব না।',
        'প্রাকৃতিক বন সাফ করব না বা তাকে বাগিচা বা অন্য কোনো ব্যবহারে বদলাব না, এবং কোনো জিনগতভাবে পরিবর্তিত (GM) গাছ লাগাব না।',
        'FSC-র অত্যন্ত বিপজ্জনক কীটনাশকের তালিকায় থাকা কোনো রাসায়নিক ব্যবহার করব না; অন্যগুলি কেবল দরকার হলে ব্যবহার করব, সুরক্ষা সরঞ্জাম পরে, নিরাপদে মজুত করে এবং খালি পাত্র নিরাপদে ফেলে; কখনও অবশিষ্টাংশ পোড়াব না।',
        'আইনি কাজের বয়সের কম কোনো শিশুকে কাজে লাগাব না, কোনো জোরপূর্বক শ্রম নেব না, কারও প্রতি বৈষম্য করব না, শ্রমিকদের সংগঠিত হওয়ার অধিকারকে সম্মান করব, অন্তত ন্যূনতম মজুরি দেব, এবং সুরক্ষা সরঞ্জাম ও প্রাথমিক চিকিৎসার ব্যবস্থা রেখে শ্রমিকদের নিরাপদ রাখব।',
        'পথ, জল ও বনজ দ্রব্যের উপর প্রতিবেশী ও সম্প্রদায়ের প্রথাগত অধিকারকে সম্মান করব, এবং কৃষক উৎপাদক গোষ্ঠীর প্রক্রিয়া অনুযায়ী বিরোধ মেটাব।',
        'কৃষক উৎপাদক গোষ্ঠী, সার্টিফিকেশন সংস্থা, FSC এবং তার স্বীকৃতি পরিষেবা (ASI)-কে আমার প্লটে আসতে দেব এবং আমার নথিপত্র দেখতে দেব।',
        '{org}, সার্টিফিকেশন সংস্থা বা যাচাইকারী যে পর্যবেক্ষণ বা সংশোধনমূলক পদক্ষেপ চিহ্নিত করবে, তা সম্মত সময়ের মধ্যে সমাধান করব। আমি বুঝি যে সমাধান না হওয়া বিষয় সংশ্লিষ্ট কর্মসূচি বা দাবিতে আমার প্লট বা ফসলের অন্তর্ভুক্তিকে প্রভাবিত করতে পারে।',
        'FSC দাবিযুক্ত ফসল কেবল কৃষক উৎপাদক গোষ্ঠীর মাধ্যমেই বিক্রি করব, চালানে (ইনভয়েস) তার সার্টিফিকেট কোড রেখে, এবং FSC নাম বা লোগো কেবল কৃষক উৎপাদক গোষ্ঠী যেভাবে অনুমতি দেয় সেভাবেই ব্যবহার করব।',
      ],
      rights: ['যতদিন আমার প্লট নিয়ম মেনে চলে, ততদিন কৃষক উৎপাদক গোষ্ঠীর মাধ্যমে FSC দাবি সহ আমার ফসল বিক্রি করার অধিকার।', 'কৃষক উৎপাদক গোষ্ঠীর নিয়ম এবং আমার প্লটের ব্যবস্থাপনা পরিকল্পনা দেখার অধিকার।'],
    },
    FSC_CW: {
      title: 'FSC কন্ট্রোলড উড (যাচাই)',
      about: 'যে কাঠ FSC সার্টিফায়েড নয়, তা-ও FSC কন্ট্রোলড উড হিসেবে বিক্রি করা যায়, যদি যাচাই করা হয় যে তা গ্রহণযোগ্য উৎস থেকে এসেছে। আমার প্লট সেই জন্য যাচাই করা হয়।',
      obligations: [
        'আমার প্লটের কাঠ আইনসম্মতভাবে কাটা ও পরিবহন করা হয়, আইনে প্রয়োজনীয় প্রতিটি অনুমতিপত্র ও কর সহ।',
        'এটি এমন জমি থেকে আসে না যেখানে প্রতিবেশী, সম্প্রদায় বা শ্রমিকদের প্রথাগত, নাগরিক বা মানবাধিকারকে সম্মান করা হয় না।',
        'এটি এমন এলাকা থেকে আসে না যেখানে কাঠ কাটার ফলে উচ্চ সংরক্ষণ মূল্য বিপন্ন হয়।',
        'এটি এমন প্রাকৃতিক বন থেকে আসে না যাকে বাগিচা বা অন্য ব্যবহারে বদলানো হচ্ছে।',
        'এটি জিনগতভাবে পরিবর্তিত (GM) গাছ থেকে আসে না।',
        'কাঠের প্রতিটি লট কোথা থেকে এসেছে - প্লট, প্রজাতি ও পরিমাণ - তার সত্য তথ্য দেব, যাতে তা খুঁজে বের করা যায়।',
        '{org} ও তার যাচাইকারীদের আমার প্লটে আসতে এবং আমার জমি, অনুমতিপত্র ও কাঠ কাটার কাগজপত্র দেখতে দেব, এবং কোনো পরিবর্তন হলে তাদের জানাব।',
      ],
      rights: ['যতদিন যাচাই বহাল থাকে, ততদিন {org}-এর মাধ্যমে আমার কাঠ FSC কন্ট্রোলড উড হিসেবে বিক্রি করার অধিকার।'],
    },
    EUDR: {
      title: 'ইউরোপীয় ইউনিয়নের বন উজাড় বিধি (EUDR)',
      about: 'ইউরোপীয় ইউনিয়নে বিক্রি হওয়া কাঠ ও অন্যান্য পণ্যকে প্রমাণ করতে হয় যে 31 ডিসেম্বর 2020-এর পরে কোনো বন উজাড় হয়নি এবং তা আইনসম্মতভাবে উৎপাদিত। {org} একটি যথাযথ যাচাই বিবৃতি (ডিউ ডিলিজেন্স স্টেটমেন্ট) জমা দেয়, যাতে আমার প্লট অন্তর্ভুক্ত।',
      obligations: [
        'আমার প্লটের সীমানা (তার ভৌগোলিক অবস্থান) নথিভুক্ত করতে, এবং যথাযথ যাচাই বিবৃতিতে ক্রেতা ও ইউরোপীয় ইউনিয়নের কর্তৃপক্ষের সঙ্গে ভাগ করতে দেব।',
        '31 ডিসেম্বর 2020-এর পরে আমার প্লটে কোনো বন উজাড় বা বনের অবক্ষয় হতে দেব না।',
        'ভারতের আইন মেনে আইনসম্মতভাবে উৎপাদন করব: জমি ব্যবহারের অধিকার, পরিবেশ ও বন বিধি, জমির উপর অন্যদের অধিকার, শ্রম ও মানবাধিকার, যেখানে প্রযোজ্য সেখানে স্বাধীন, পূর্ব-অবহিত ও জেনেবুঝে দেওয়া সম্মতি, কর, দুর্নীতি-বিরোধী, বাণিজ্য ও শুল্ক আইন।',
        'আমার জমি, আমার ফসল কাটা এবং আমার ফসল কোথায় যায় সে বিষয়ে সত্য তথ্য দেব, এবং এই প্লটের ফসলকে অন্য যেকোনো জায়গার ফসল থেকে আলাদা রাখব।',
        'প্লটের সীমানা, ব্যবহার বা মালিকানায় কোনো পরিবর্তন হলে, এবং তাতে কোনো গাছপালা সাফ করা হলে, সঙ্গে সঙ্গে {org}-কে জানাব।',
        'বিধি অনুযায়ী {org}-কে এই তথ্য অন্তত পাঁচ বছর রাখতে এবং কর্তৃপক্ষকে দেখাতে দেব।',
      ],
      rights: ['আমার প্লট সম্পর্কে কী এবং কার সঙ্গে ভাগ করা হয়, তা জানার অধিকার।'],
    },
    GLOBALGAP: {
      title: 'GLOBALG.A.P. (উত্তম কৃষি পদ্ধতি)',
      about: 'GLOBALG.A.P. খুচরো বিক্রেতাদের কাছে বিক্রি হওয়া খাদ্য ও গাছপালার নিরাপদ ও টেকসই চাষের প্রমাণপত্র দেয়। আমার প্লট {org}-এর গোষ্ঠী সার্টিফিকেটে আছে।',
      obligations: [
        'কৃষক উৎপাদক গোষ্ঠীর গুণমান ব্যবস্থাপনা পদ্ধতি ও নিয়ম মেনে চলব, এবং প্রতি বছর তার অভ্যন্তরীণ পরিদর্শনে অংশ নেব।',
        'আমি কী লাগাই, কোন উপকরণ কখন দিই, এবং আমার ফসল কাটার হিসাব রাখব, যাতে প্রতিটি লট আমার প্লট পর্যন্ত খুঁজে বের করা যায়; সার্টিফায়েড ও অন্য ফসল আলাদা রাখব।',
        'কেবল সেই ফসলের জন্য অনুমোদিত উদ্ভিদ সুরক্ষা পণ্য ব্যবহার করব, সঠিক মাত্রায়, সুরক্ষা সরঞ্জাম পরা প্রশিক্ষিত ব্যক্তির দ্বারা প্রয়োগ করে, এবং ফসল কাটার আগে অপেক্ষার সময় মেনে চলব; সেগুলি তালাবন্ধ করে রাখব এবং খালি পাত্র নিরাপদে ফেলব।',
        'সার ব্যবহারের হিসাব রাখব; মানুষের নর্দমার পাঁক (স্লাজ) ব্যবহার করব না; যে কাজের জন্য জল ব্যবহার হবে, সেই কাজের জন্য নিরাপদ জল ব্যবহার করব।',
        'ফসল, ফসল কাটার যন্ত্রপাতি ও পাত্র পরিষ্কার রাখব, এবং ফসল তোলার শ্রমিকদের জন্য হাত ধোয়ার ব্যবস্থা ও শৌচালয় রাখব।',
        'শ্রমিকদের নিরাপদ, প্রশিক্ষিত ও অবহিত রাখব, প্রাথমিক চিকিৎসা, পরিষ্কার পানীয় জল এবং ন্যায্য আচরণ সহ।',
        'বর্জ্য ও দূষণ ঠিকমতো সামলাব; আমার প্লটে ও তার চারপাশে মাটি, জল ও বন্যপ্রাণী রক্ষা করব।',
        'কোনো অভিযোগ, দূষণ বা খাদ্য নিরাপত্তার সমস্যা হলে সঙ্গে সঙ্গে কৃষক উৎপাদক গোষ্ঠীকে জানাব, এবং দরকার হলে বাজার থেকে ফসল তুলে নেওয়া বা ফেরত আনায় অংশ নেব।',
        'কৃষক উৎপাদক গোষ্ঠীর পরিদর্শক ও সার্টিফিকেশন সংস্থাকে আমার প্লট ও নথিপত্র পরিদর্শন করতে, এবং অবশিষ্ট রাসায়নিক পরীক্ষার জন্য নমুনা নিতে দেব।',
      ],
      rights: ['যতদিন আমার প্লট নিয়ম মেনে চলে, ততদিন আমার ফসল GLOBALG.A.P. সার্টিফায়েড হিসেবে বিক্রি করার অধিকার।'],
    },
    PEFC: {
      title: 'PEFC (টেকসই বন ব্যবস্থাপনা)',
      about: 'PEFC টেকসইভাবে পরিচালিত বন ও গাছের খামারের প্রমাণপত্র দেয়। {org}-এর কৃষক উৎপাদক গোষ্ঠীর অংশ হিসেবে আমার প্লট সার্টিফায়েড।',
      obligations: [
        'আমার জমিতে বন, পরিবেশ, শ্রম ও কর আইন সহ সব আইন মেনে চলব, এবং গাছ কাটা ও পরিবহনের জন্য প্রয়োজনীয় অনুমতিপত্র রাখব।',
        'কৃষক উৎপাদক গোষ্ঠীর পরিকল্পনা অনুযায়ী আমার গাছের যত্ন নেব: সেগুলিকে উৎপাদনশীল ও সুস্থ রাখব, যতটা আবার বাড়ে তার বেশি কাটব না, এবং আবার গাছ লাগাব বা স্বাভাবিকভাবে নতুন গাছ গজাতে দেব।',
        'বনকে অন্য কোনো জমি ব্যবহারে বদলাব না, এবং কোনো জিনগতভাবে পরিবর্তিত (GM) গাছ লাগাব না।',
        'মাটি ও জল রক্ষা করব, নদী-নালার ধারে ফাঁকা সুরক্ষিত অংশ (বাফার) রাখব, এবং আমার প্লটের জীববৈচিত্র্য ও পরিবেশগতভাবে গুরুত্বপূর্ণ এলাকা রক্ষা করব।',
        'অত্যন্ত বা খুব বিপজ্জনক হিসেবে শ্রেণিভুক্ত কোনো কীটনাশক ব্যবহার করব না; রাসায়নিক কেবল দরকার হলে, নিরাপদে এবং লেবেলে যেমন লেখা আছে তেমনভাবে ব্যবহার করব।',
        'শ্রমিকদের মৌলিক অধিকারকে সম্মান করব - কোনো শিশু শ্রম বা জোরপূর্বক শ্রম নয়, কোনো বৈষম্য নয়, সংগঠিত হওয়ার স্বাধীনতা - এবং তাদের নিরাপদ রাখব।',
        'স্থানীয় সম্প্রদায়ের অধিকার, এবং আমার প্লটে বা তার কাছে থাকা সাংস্কৃতিক ও আধ্যাত্মিক স্থানগুলিকে সম্মান করব।',
        'আমার কাছে যে নথি রাখতে বলা হয় তা রাখব, কৃষক উৎপাদক গোষ্ঠী ও সার্টিফিকেশন সংস্থার নিরীক্ষা (অডিট) করতে দেব, এবং তারা যে সংশোধনমূলক পদক্ষেপ চিহ্নিত করবে তা সম্মত সময়ের মধ্যে সমাধান করব।',
        'PEFC দাবিযুক্ত কাঠ কেবল কৃষক উৎপাদক গোষ্ঠীর মাধ্যমেই বিক্রি করব, এবং PEFC নাম বা লোগো কেবল কৃষক উৎপাদক গোষ্ঠী যেভাবে অনুমতি দেয় সেভাবেই ব্যবহার করব।',
      ],
      rights: ['যতদিন আমার প্লট নিয়ম মেনে চলে, ততদিন কৃষক উৎপাদক গোষ্ঠীর মাধ্যমে PEFC দাবি সহ আমার কাঠ বিক্রি করার অধিকার।'],
    },
    ORGANIC: {
      title: 'জৈব (NPOP / NOP)',
      about: 'জৈব সার্টিফিকেশন দেখায় যে ফসল কৃত্রিম সার ও কীটনাশক ছাড়াই ফলানো হয়েছে। আমার প্লট {org}-এর জৈব চাষি গোষ্ঠীতে, তার অভ্যন্তরীণ নিয়ন্ত্রণ ব্যবস্থার অধীনে আছে।',
      obligations: [
        'আমার ফসল জৈব হিসেবে বিক্রি হওয়ার আগে রূপান্তরকাল (কনভার্শন পিরিয়ড) পূর্ণ করব।',
        'কোনো কৃত্রিম সার, কীটনাশক, আগাছানাশক বা বৃদ্ধি নিয়ন্ত্রক ব্যবহার করব না, কোনো জিনগতভাবে পরিবর্তিত (GM) বীজ বা চারা ব্যবহার করব না, এবং কোনো নর্দমার পাঁক (স্লাজ) ব্যবহার করব না।',
        'কেবল জৈব মানদণ্ডে অনুমোদিত উপকরণ ব্যবহার করব, এবং তাদের বিল ও লেবেল রেখে দেব।',
        'পাশের সাধারণ (অজৈব) চাষের জমি থেকে ফাঁকা সুরক্ষিত অংশ (বাফার) রাখব, এবং সেখান থেকে রাসায়নিক উড়ে আসা ও দূষণ আটকাব।',
        'আমি যদি সাধারণ (অজৈব) ফসলও চাষ করি, তবে সেগুলি স্পষ্টভাবে আলাদা রাখব, এবং কখনও অজৈব ফসল জৈব ফসলের সঙ্গে মেশাব না।',
        'আমার উপকরণ, ফসল কাটা ও বিক্রির হিসাব রাখব; জৈব ফসলের জন্য পরিষ্কার, আলাদা বস্তা ও গুদাম ব্যবহার করব।',
        'অভ্যন্তরীণ নিয়ন্ত্রণ ব্যবস্থার নিয়ম মেনে চলব, তার প্রশিক্ষণে যোগ দেব, এবং তার পরিদর্শন ও নমুনা পরীক্ষা করতে দেব; আমি বুঝি যে কোনো শর্ত পূরণ না হলে আমার ফসল জৈব হিসেবে বিক্রি করা যাবে কি না, তা প্রভাবিত হতে পারে।',
        'ফসল কেবল কৃষক উৎপাদক গোষ্ঠীর মাধ্যমেই জৈব হিসেবে বিক্রি করব, এবং কেবল কৃষক উৎপাদক গোষ্ঠী যেভাবে অনুমতি দেয় সেভাবেই লেবেল লাগাব।',
        'কোনো নিষিদ্ধ পদার্থ ব্যবহার হলে, দূষণ হলে, বা আমার জমিতে কোনো পরিবর্তন হলে সঙ্গে সঙ্গে কৃষক উৎপাদক গোষ্ঠীকে জানাব।',
      ],
      rights: ['যতদিন আমার প্লট নিয়ম মেনে চলে, ততদিন কৃষক উৎপাদক গোষ্ঠীর মাধ্যমে আমার ফসল জৈব হিসেবে বিক্রি করার অধিকার।'],
    },
    CARBON: {
      title: 'কার্বন প্রকল্প',
      about: 'আমার প্লটের গাছগুলি কার্বন জমা করে রাখে। {org} আমার প্লটকে একটি কার্বন প্রকল্পে অন্তর্ভুক্ত করেছে, যা এটি মাপে এবং এর জন্য কার্বন ক্রেডিট বিক্রি করতে পারে।',
      obligations: [
        'প্রকল্প চুক্তিতে যেমন বলা আছে, প্রকল্পের ক্রেডিট পাওয়ার সময়কালের জন্য আমার প্লটের প্রকল্প-গাছগুলি থেকে পাওয়া কার্বন ক্রেডিটের অধিকার প্রকল্পকে হস্তান্তর করব।',
        'প্রকল্পের মেয়াদ পর্যন্ত প্রকল্প-গাছগুলি দাঁড়িয়ে থাকতে দেব; তার কোনোটি কাটার আগে {org}-কে জানাব, এবং যেগুলি মারা যায় সেগুলির জায়গায় নতুন গাছ লাগাব।',
        'একই গাছ বা জমি অন্য কোনো কার্বন প্রকল্প বা স্কিমে নথিভুক্ত করব না, এবং তাদের কার্বন অন্য কাউকে বিক্রি করব না।',
        'এখানে যে গাছপালা সাফ করা বা কাটা আমি করতাম, তা অন্য জমিতে সরিয়ে নিয়ে করব না (লিকেজ)।',
        'প্রকল্পকে গাছ মাপতে, আমার প্লটের মানচিত্র তৈরি করতে এবং উপগ্রহের মাধ্যমে নজর রাখতে দেব, এবং সেই হিসাব রেজিস্ট্রি, যাচাইকারী ও ক্রেডিটের ক্রেতাদের সঙ্গে ভাগ করতে দেব।',
        'প্রকল্প-গাছগুলির উপর প্রভাব ফেলে এমন কোনো আগুন, ক্ষতি, বিরোধ বা মালিকানা বদল হলে {org}-কে জানাব।',
      ],
      rights: ['প্রকল্প চুক্তিতে যেমন বলা আছে, কার্বন আয়ের সেই অংশ পাওয়ার অধিকার, এবং তা কীভাবে হিসাব করা হয় তা দেখার অধিকার।', 'এই নথির মাধ্যমে দেওয়া, প্রকল্পে স্বাধীন, পূর্ব-অবহিত ও জেনেবুঝে সম্মতি দেওয়ার অধিকার।'],
    },
  },
  membershipDuties: [
    'আমার প্লটের জন্য কর্মসূচির শর্তগুলি মেনে চলব, এবং আমার জমি, তার মালিকানা বা তার ব্যবহারে কোনো পরিবর্তন হলে {org}-কে জানাব।',
    'প্রশিক্ষণ, অভ্যন্তরীণ পরিদর্শন ও নিরীক্ষায় (অডিট) অংশ নেব, এবং সম্মত সময়ের মধ্যে যেকোনো সংশোধনমূলক পদক্ষেপ সমাধান করব।',
    'আমি বুঝি যে প্রতিটি কর্মসূচির নিজস্ব শর্ত আছে। আমার প্লট ও ফসল প্রযোজ্য কর্মসূচির শর্তগুলি পূরণ করে চলেছে কি না, তা নির্ধারণ করতে {org} আমার প্লট ও নথিপত্র পর্যালোচনা করতে পারে।',
    'কোনো শর্ত মেনে চলা না হলে, আমি বুঝি যে আমার প্লট বা ফসল সংশ্লিষ্ট কর্মসূচি বা দাবিতে অন্তর্ভুক্ত থাকতে পারবে কি না, {org} তা পর্যালোচনা করতে পারে।',
    'সত্য নথি রাখব, এবং কখনও অন্য কোনো জায়গার ফসলকে আমার প্লটের ফসল বলে চালাব না।',
  ],
  dataNotice: {
    collected: 'আমার নাম ও পরিবারের বিবরণ, ঠিকানা, ফোন ও ইমেল, পরিচয়পত্র ও জমির কাগজের নম্বর (আংশিক ঢাকা অবস্থায় রাখা), ছবি, আমার প্লটের সীমানা ও অবস্থান, তাতে থাকা গাছ ও চাষের পদ্ধতি, এবং আমার ফসল কাটা, বিক্রি ও প্রাপ্ত টাকার হিসাব।',
    purposes: 'আমাকে ও আমার প্লটকে নথিভুক্ত করতে, এই নথিতে উল্লিখিত কর্মসূচিগুলির অধীনে প্লটটিকে সার্টিফাই করতে, আমার ফসলকে তার দাবি সহ খুঁজে বের করতে ও বিক্রি করতে, যথাযথ যাচাই বিবৃতি জমা দিতে, কার্বন মাপতে, এবং আমাকে টাকা দিতে।',
    sharedWith: 'যেখানে প্রাসঙ্গিক: সার্টিফিকেশন সংস্থা, নিরীক্ষক (অডিটর), কর্মসূচি বা মানদণ্ডের মালিক, যাচাইকারী, রেজিস্ট্রি, ক্রেতা, সরবরাহ-শৃঙ্খলের অংশীদার, প্রকল্পের অংশীদার এবং সরকারি কর্তৃপক্ষ। ক্রেতা ও সরবরাহ-শৃঙ্খলের অংশীদাররা যা পায়, তা ফসলের উৎস খুঁজে বের করা, যাচাই, যথাযথ যাচাই, সার্টিফিকেশন বা বিক্রির জন্য যুক্তিসঙ্গতভাবে যতটুকু দরকার ততটুকুতেই সীমিত। আমার ব্যক্তিগত তথ্য অসম্পর্কিত বিপণনের উদ্দেশ্যে বিক্রি করা হবে না।',
    retention: 'যতদিন এই সম্মতি বহাল থাকে ততদিন, এবং তার পরেও যতদিন আইন বা কোনো কর্মসূচি দাবি করে ততদিন (EUDR নথির জন্য অন্তত পাঁচ বছর)।',
    rights: 'আমার সম্পর্কে রাখা তথ্য দেখার, তা সংশোধন বা সম্পূর্ণ করানোর, কোনো আইন বা কর্মসূচির আর প্রয়োজন না থাকলে তা মুছে ফেলানোর, যেকোনো সময় এই সম্মতি প্রত্যাহারের অনুরোধ করার, এবং আমার হয়ে কাজ করার জন্য কাউকে মনোনীত করার অধিকার।',
  },
  sharing: {
    intro: 'আমি রাজি যে এই সম্মতিতে বলা উদ্দেশ্যগুলির জন্য {org} আমার ও আমার প্লট সম্পর্কে তথ্য সংগ্রহ, নথিভুক্ত, ব্যবহার ও রক্ষণাবেক্ষণ করতে পারে। আমি {org}-কে আমার, আমার প্লট, উৎপাদন, ফসল কাটা ও লেনদেন সম্পর্কে প্রাসঙ্গিক তথ্য নিম্নলিখিতদের সঙ্গে ভাগ করার অনুমতি দিচ্ছি:',
    recipients: [
      'সার্টিফিকেশন সংস্থা ও নিরীক্ষক (অডিটর);',
      'কর্মসূচির মালিক, মানদণ্ডের মালিক ও যাচাইকারী সংস্থা;',
      'যেখানে প্রয়োজন, সরকারি ও নিয়ন্ত্রক কর্তৃপক্ষ;',
      'ক্রেতা ও সরবরাহ-শৃঙ্খলের অংশীদার, যেখানে উৎস খুঁজে বের করা, দাবি যাচাই, যথাযথ যাচাই বা লেনদেনের শর্তের জন্য তথ্যটি দরকার;',
      'যেখানে প্রযোজ্য, কার্বন প্রকল্পের রেজিস্ট্রি, যাচাইকারী ও সংশ্লিষ্ট প্রকল্প অংশীদার; এবং',
      'মানচিত্র তৈরি, নজরদারি, তথ্য ব্যবস্থাপনা বা যাচাইয়ে সহায়তাকারী পরিষেবা প্রদানকারী।',
    ],
    limits: [
      'কেবল প্রযোজ্য কর্মসূচি, দাবি, যাচাই, উৎস খুঁজে বের করা বা লেনদেনের সঙ্গে প্রাসঙ্গিক তথ্যই ভাগ করা হবে।',
      '{org} অসম্পর্কিত বিপণনের উদ্দেশ্যে আমার ব্যক্তিগত তথ্য বিক্রি করবে না।',
      'আমি বুঝি যে ফসলের উৎস ও নিয়ম মেনে চলা প্রমাণ করতে আমার প্লট সম্পর্কে কিছু তথ্য, যেমন তার অবস্থান, উৎপাদন, ফসল কাটা ও উৎস খুঁজে বের করার তথ্য, ভাগ করার প্রয়োজন হতে পারে।',
    ],
    statements: [
      'আমি রাজি যে উৎস, উৎস খুঁজে বের করা, সার্টিফিকেশনের দাবি, যথাযথ যাচাই বা নিয়ম মেনে চলার শর্ত প্রমাণ করার প্রয়োজন হলে, আমার প্লট ও ফসল সম্পর্কে প্রাসঙ্গিক তথ্য ক্রেতা ও সরবরাহ-শৃঙ্খলের অংশীদারদের সঙ্গে ভাগ করা যেতে পারে।',
      'আমি রাজি যে এই সম্মতির আওতাভুক্ত উদ্দেশ্যগুলির জন্য ছবি, প্লটের মানচিত্র, উৎপাদনের তথ্য, ফসল কাটার তথ্য এবং সংশ্লিষ্ট নথিপত্র অনুমোদিত কর্মসূচি, সার্টিফিকেশন, যাচাই ও প্রকল্প সংস্থাগুলির সঙ্গে ভাগ করা যেতে পারে।',
    ],
    withdrawal: 'আমি যেকোনো সময় আমার সম্মতি প্রত্যাহারের অনুরোধ করতে পারি। সংশ্লিষ্ট কর্মসূচি, সার্টিফিকেশন, দাবি বা প্রকল্পে আমার অংশগ্রহণের উপর প্রত্যাহারের কী প্রভাব পড়তে পারে, {org} তা বুঝিয়ে বলবে। প্রত্যাহারের আগে যে তথ্য ইতিমধ্যে ব্যবহার বা ভাগ করা হয়েছে, নথি, আইন, সার্টিফিকেশন, উৎস খুঁজে বের করা বা কর্মসূচির শর্তের জন্য প্রয়োজন হলে তা রেখে দেওয়া চলতে পারে।',
  },
};
